import SendIcon from '@mui/icons-material/Send';
import { Button, CircularProgress, Grid, TextField } from '@mui/material';
import { useState } from 'react';

interface ICommentInputControlProps {
  initialComment: string;
  onCommentAdd: (comment: string) => Promise<unknown>;
  /**
   * Whether to disable the input control for comment
   */
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
}

export default function CommentInputControl({
  initialComment = '',
  disabled = false,
  onCommentAdd
}: ICommentInputControlProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState(initialComment);
  return (
    <Grid item xs={12} sx={{ position: 'relative' }}>
      <TextField
        id='outlined-multiline-flexible'
        placeholder='Type your comment to describe opportunity'
        multiline
        maxRows={3}
        value={comment}
        fullWidth
        size='small'
        inputProps={{
          style: {
            fontSize: '12px',
            lineHeight: '14px',
            margin: '0 22px 0 -8px'
          }
        }}
        className='comment-input-box'
        onChange={(event) => setComment(event.target.value)}
      />
      <Button
        size='small'
        color='primary'
        onClick={() => {
          setIsLoading(true);
          onCommentAdd(comment).finally(() => {
            setComment('');
            setIsLoading(false);
          });
        }}
        variant='contained'
        disabled={comment.trim().length === 0 || isLoading || disabled}
        aria-label='send'
        sx={{
          position: 'absolute',
          bottom: 6,
          right: 3,
          fontSize: '14px',
          minWidth: 'auto'
        }}
      >
        {isLoading ? (
          <CircularProgress
            size='small'
            sx={{ height: '10px', width: '10px' }}
          />
        ) : (
          <SendIcon fontSize='inherit' />
        )}
      </Button>
    </Grid>
  );
}
